import { Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../../services/richieste.service';
import { StoricoRichiesta } from '../../../models/storico-richiesta.model';
import { StiliService } from '../../../services/stili.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { Richiesta } from '../../../models/richiesta.model';

@Component({
  selector: 'app-storico',
  standalone: true,
  imports: [
    CommonModule,
    TimelineModule,
    CardModule,
    ButtonModule,
    TagModule,
    DividerModule,
    LottieComponent,
    DialogModule
  ],
  templateUrl: './storico.component.html',
  styleUrls: ['./storico.component.css']
})
export class StoricoComponent implements OnInit, OnChanges {
  @Input() richiestaId!: number;
  @Input() richiesta: Richiesta | null = null;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  eventi: StoricoRichiesta[] = [];
  isLoading: boolean = true;

  // Configurazione animazione Lottie
  lottieConfig: AnimationOptions = {
    path: 'assets/animations/spinner-storico-richiesta.json',
    autoplay: true,
    loop: true,
    renderer: 'svg'
  };
  animazione: any;

  constructor(
    private logger: NGXLogger,
    private richiesteService: RichiesteService,
    public stiliService: StiliService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Implementa OnChanges per reagire ai cambiamenti dell'input richiestaId
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Controlla se è cambiato richiestaId e non è la prima inizializzazione
    if (changes['richiestaId']) {
      if (this.richiestaId && this.richiestaId > 0) {
        console.log(`[STORICO] richiestaId cambiato da ${changes['richiestaId'].previousValue} a ${changes['richiestaId'].currentValue}`);
        this.isLoading = true; // Attiva loader
        this.caricaEventiStorico();
      }
    }
  }

  /**
   * Caricamento completato dell'animazione Lottie
   */
  animationCreated(animation: any): void {
    this.animazione = animation;
    this.logger.info("[STORICO] Lottie animation created");
  }

  /**
   * Carica gli eventi dello storico della richiesta
   * Implementazione di esempio con dati fittizi
   */
  caricaEventiStorico(): void {
    console.log(`[STORICO] Caricamento eventi per la richiesta ${this.richiestaId}`);
    this.isLoading = true; // Assicurati che il loader sia visibile
    this.richiesteService.getStoricoRichiesta(this.richiestaId).subscribe({
      next: (storicoRichiesta: StoricoRichiesta[]) => {
        this.eventi = storicoRichiesta;
        this.logger.info(`[STORICO] Eventi storico caricati: ${this.eventi.length}`);
        this.logger.info(this.eventi);
        this.isLoading = false; // Disattiva loader quando i dati sono pronti
      },
      error: (err) => {
        this.logger.error(`[STORICO] Errore nel caricamento eventi: ${err}`);
        this.isLoading = false; // Disattiva loader anche in caso di errore
      }
    });
  }

  show(richiesta: Richiesta) {
    this.richiestaId = richiesta.id;
    this.richiesta = richiesta;
    this.visible = true;
    this.visibleChange.emit(true);
    this.caricaEventiStorico();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.richiesta = null;
    this.eventi = [];
    this.richiestaId = 0;
  }

  /**
   * Restituisce il colore appropriato per il tag in base al tipo di evento
   */
  getColorTag(tipo: string): 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast' {
    switch(tipo) {
      case 'creazione': return 'info';
      case 'modifica': return 'warning';
      case 'finanziamento': return 'success';
      case 'rendicontazione': return 'secondary'; // Cambiato da 'primary'
      default: return 'secondary';
    }
  }

  /**
   * Formatta la data in formato leggibile
   */
  formatDate(date: Date): string {
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Ottiene le chiavi di un oggetto
   */
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  /**
   * Verifica se un valore è un array
   */
  isArray(value: any): boolean {
    return Array.isArray(value);
  }
}
